import {
  CapsVariation,
  DenseVariation,
  OpenVariation,
} from '@americastestkitchen/mise';
import { PrintFontOptions } from 'types/recipe';

export const getOpenPrintSize = (
  fontSize: PrintFontOptions,
): OpenVariation['size'] => {
  if (fontSize === 'large') return 'xlg';
  if (fontSize === 'normal') return 'md';
  if (fontSize === 'small') return 'sm';
};

export const getDensePrintSize = (
  fontSize: PrintFontOptions,
): DenseVariation['size'] => {
  if (fontSize === 'large') return 'lg';
  if (fontSize === 'normal') return 'md';
  if (fontSize === 'small') return 'sm';
};

export const getCapsPrintSize = (
  fontSize: PrintFontOptions,
): CapsVariation['size'] => {
  if (fontSize === 'large') return 'lg';
  if (fontSize === 'normal') return 'md';
  if (fontSize === 'small') return 'sm';
};
